import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';
import YearPicker from "dashboards/lite/YearPicker";

export default function OrganicSocialDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["overall", "sessions"], props.table_data) ? Object.keys(jsDig(["overall", "sessions"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  // Read the 'year' query param if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const queryYear = parseInt(urlParams.get("year"), 10);

  // If queryYear is not a valid number, use the current year, else use queryYear
  const thisYear = isNaN(queryYear) ? new Date().getFullYear() : queryYear;
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/social.svg");
  let followerIcon = <div className="dashboard-icon"><img className="dashboard-icon-2 filter-grey" src={`/datapulse${mainIcon}`} /></div>
  mainIcon = <div className="organic-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>
  let disabledIcon = require("images/lite/icons/coming-soon.png");
  disabledIcon = <div className="coming-soon-icon"><img src={`/datapulse${disabledIcon}`} /></div>

  let facebookIcon = require("images/lite/icons/facebook.png");
  facebookIcon = <img className="followers-icon" src={`/datapulse${facebookIcon}`}/>
  let instagramIcon = require("images/lite/icons/instagram.svg");
  instagramIcon = <img className="followers-icon" src={`/datapulse${instagramIcon}`}/>
  let tiktokIcon = require("images/lite/icons/tiktok.png");
  tiktokIcon = <img className="followers-icon" src={`/datapulse${tiktokIcon}`}/>
  let youtubeIcon = require("images/lite/icons/youtube.png");
  youtubeIcon = <img className="followers-icon" src={`/datapulse${youtubeIcon}`}/>
  let twitterIcon = require("images/lite/icons/twitter.svg");
  twitterIcon = <img className="followers-icon" src={`/datapulse${twitterIcon}`}/>
  let linkedinIcon = require("images/lite/icons/linkedin.svg");
  linkedinIcon = <img className="followers-icon" src={`/datapulse${linkedinIcon}`}/>
  let snapchatIcon = require("images/lite/icons/snapchat.png");
  snapchatIcon = <img className="followers-icon" src={`/datapulse${snapchatIcon}`}/>
  let otherIcon = require("images/lite/icons/other.svg");
  otherIcon = <img className="followers-icon" src={`/datapulse${otherIcon}`}/>

  function formatNumber(num) {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'k'; // Converts the number to 'k' format
    }
    return num.toString(); // Returns the number as a string if under 1000
  }

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  const dashboardType = "organic_social"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});

  const followerCards = [
    {
      platform: "Facebook",
      icon: facebookIcon,
      followers: 157500,
      followersChange: 1500,
    },
    {
      platform: "Instagram",
      icon: instagramIcon,
      followers: 57500,
      followersChange: 500,
    },
    {
      platform: "TikTok",
      icon: tiktokIcon,
      followers: 57500,
      followersChange: 2500,
    },
    {
      platform: "YouTube",
      icon: youtubeIcon,
      followers: 97500,
      followersChange: 1500,
    },
    {
      platform: "Twitter",
      icon: twitterIcon,
      followers: 57500,
      followersChange: -500,
    },
    {
      platform: "LinkedIn",
      icon: linkedinIcon,
      followers: 1300,
      followersChange: 42,
    },
    {
      platform: "Snapchat",
      icon: snapchatIcon,
      followers: 57500,
      followersChange: 500,
    },
    {
      platform: "Other",
      icon: otherIcon,
      followers: 57500,
      followersChange: 500,
    }
  ]

  return (
    <>
      <div className="lite-dashboard organic-social-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Organic Social Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <YearPicker/>
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"organic_social"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
              <LiteExportPDF companyName={props.company_name} dashName="Organic-Social" />
            </div>
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "sessions", "data"], props.chart_data)}
                chartName="Organic Social Traffic L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", revenueOrConversions, "data"], props.chart_data)}
                chartName={`Organic Social ${capitalize(revenueOrConversions)} L60D`}
                metric={revenueOrConversions}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "followers", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "followers", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "followers", "data"], props.chart_data)}
                chartName="Total Followers L60D"
                metric="followers"
                colorBlindAssist={props.color_blind_assist}
                disabledMsg={<>{disabledIcon}<p>Metric coming soon!</p></>}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-cards-container">
              <div className="lite-metric-cards-top" style={{opacity: 0.5}}>
                <b style={{display: "flex", alignItems: "center", fontSize: "18px"}}>{followerIcon} Followers (vs. last week)</b>
              </div>
              <div className="lite-metric-cards-bottom" style={{opacity: 0.5}}>
                {
                  followerCards.map((card, index) => {
                    return(
                      <div className="lite-metric-card-container" key={index}>
                        <div className="lite-metric-card-top">
                          {card.icon}<p className="follower-title">{card.platform}</p>
                        </div>
                        <div className="lite-metric-card-bottom">
                          <div className="followers">
                            {formatNumber(card.followers)}
                          </div>
                            {card.followersChange >= 0 ? 
                          <div className="followers-change  positive">+{formatNumber(card.followersChange)}</div> :
                          <div className="followers-change negative">{formatNumber(card.followersChange)}</div>
                          }
                        </div>
                      </div>
                    )
                  }
                  )
                }
              </div>
              <div className="coming-soon-container">
                {disabledIcon}<p>Engagement metrics coming soon!</p>
              </div>
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", "conversions", "revenue"]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "total"], props.table_data)}
                tableName="Total Organic Social"
                dimensions={metricTableDimensions}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "traffic_by_source", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "traffic_by_source", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "traffic_by_source", "sessions", "data"], props.chart_data)}
                chartName="Organic Social Traffic By Source L60D"
                metric="stacked"
                tooltipData={jsDig(["overall", "traffic_by_source", "sessions", "tooltip_data"], props.chart_data)}
                tooltipMetric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "views", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "views", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "views", "data"], props.chart_data)}
                chartName="Views L60D"
                fixedHeight={300}
                metric="views"
                disabledMsg={<>{disabledIcon}<p>Metric coming soon!</p></>}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "likes", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "likes", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "likes", "data"], props.chart_data)}
                chartName="Likes L60D"
                fixedHeight={300}
                metric="likes"
                disabledMsg={<>{disabledIcon}<p>Metric coming soon!</p></>}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "comments", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "comments", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "comments", "data"], props.chart_data)}
                chartName="Comments L60D"
                fixedHeight={300}
                metric="comments"
                colorBlindAssist={props.color_blind_assist}
                disabledMsg={<>{disabledIcon}<p>Metric coming soon!</p></>}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "saves_favorites_shares", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "saves_favorites_shares", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "saves_favorites_shares", "data"], props.chart_data)}
                chartName="Save/Favorite/Share L60D"
                fixedHeight={300}
                metric="save_favorite_share"
                colorBlindAssist={props.color_blind_assist}
                disabledMsg={<>{disabledIcon}<p>Metric coming soon!</p></>}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", "conversions", "revenue"]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "l60"], props.table_data)}
                tableName="Total Organic Social - Daily L60D"
                dimensions={jsDig(["overall", "l60", "sessions"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "sessions"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
